import React from 'react'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import LoadingSpinner from 'components/LoadingSpinner'
import { selectContext } from 'selectors/auth'
import { isAdminUser, isScratchAdminUser } from 'util/user'

/**
 * Guard that restricts access to Admin or Scratch Admin users.
 * Non-admin users are redirected to /dashboard.
 */
const AdminGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const context = useSelector(selectContext)

	if (!context.user) {
		return <LoadingSpinner />
	}

	if (!isAdminUser(context.user) && !isScratchAdminUser(context.user)) {
		return <Navigate to="/dashboard" replace />
	}

	return <>{children}</>
}

export default AdminGuard
